import { DateTime } from 'luxon';

const now = DateTime.now();


function getToday() {
    const end = DateTime.now().toMillis();
    const start = now.startOf('day').toMillis();
    return { start, end };
}

function getThisWeek() {
    const end = DateTime.now().toMillis();
    const start = now.startOf('week').toMillis();
    return { start, end };
}

function getThisMonth() {
    const end = DateTime.now().toMillis();
    const start = now.startOf('month').toMillis();
    return { start, end };
}

function getThisQuarter() {
    const end = DateTime.now().toMillis();
    const start = now.startOf('quarter').toMillis();
    return { start, end };
}

function getThisYear() {
    const end = DateTime.now().toMillis();
    const start = now.startOf('year').toMillis();
    return { start, end };
}

function getYesterday() {
    const yesterday = DateTime.now().minus({ days: 1 });
    const start = yesterday.startOf('day').toMillis();
    const end = yesterday.endOf('day').toMillis();
    return { start, end };
}

function getPreviousWeek() {
    const startOfCurrentWeek = DateTime.now().startOf('week');
    const start = startOfCurrentWeek.minus({ weeks: 1 }).toMillis();
    const end = startOfCurrentWeek.minus({ milliseconds: 1 }).toMillis();
    return { start, end };
}

function getPreviousMonth() {
    const startOfCurrentMonth = DateTime.now().startOf('month');
    const start = startOfCurrentMonth.minus({ months: 1 }).toMillis();
    const end = startOfCurrentMonth.minus({ milliseconds: 1 }).toMillis();
    return { start, end };
}

function getPreviousQuarter() {
    const startOfCurrentQuarter = DateTime.now().startOf('quarter');
    console.log(startOfCurrentQuarter.minus({ quarters: 1 }).toISO());
    const start = startOfCurrentQuarter.minus({ quarters: 1 }).toMillis();
    const end = startOfCurrentQuarter.minus({ milliseconds: 1 }).toMillis();
    return { start, end };
}

function getPreviousYear() {
    const startOfCurrentYear = DateTime.now().startOf('year');
    const start = startOfCurrentYear.minus({ years: 1 }).toMillis();
    const end = startOfCurrentYear.minus({ milliseconds: 1 }).toMillis();
    return { start, end };
}

function getDateFromTS(ts) {
    return DateTime.fromMillis(ts*1000).toJSDate();
}

function getLast(value, period) {
    let startDate, endDate;
    switch (period) {
        case 'day':
            endDate = now.startOf('day').minus({ millisecond: 1 });
            startDate = endDate.minus({ days: value }).plus({ millisecond: 1 });
            return { start: startDate.toMillis(), end: endDate.toMillis() };
        case 'week':
            endDate = now;
            startDate = endDate.minus({ weeks: value });
            return { start: startDate.toMillis(), end: endDate.toMillis() };
        case 'month':
            endDate = now;
            startDate = endDate.minus({ months: value });
            return { start: startDate.toMillis(), end: endDate.toMillis() };
        case 'quarter':
            endDate = now;
            startDate = endDate.minus({ quarters: value });
            return { start: startDate.toMillis(), end: endDate.toMillis() };
        case 'year':
            endDate = now;
            startDate = endDate.minus({ years: value });
            return { start: startDate.toMillis(), end: endDate.toMillis() };
        default:
            return { start: 0, end: 0 };
    }
}

export default {
    getLast,
    getToday,
    getThisWeek,
    getThisMonth,
    getThisQuarter,
    getThisYear,
    getYesterday,
    getPreviousWeek,
    getPreviousMonth,
    getPreviousQuarter,
    getPreviousYear,
    getDateFromTS
}